import { createTheme } from '@mui/material';
const theme = createTheme({
  palette: {
    primary: {
      main: '#ed5f00',
    },
    secondary: {
      main: '#ed5f00',
    },
    info: {
      main: '#4E148C',
    },
    success: {
      main: '#4E148C',
    },
    error: {
      main: '#4E148C',
    },
    warning: {
      main: '#4E148C',
    },
  },
});
export default theme;
